import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterfn',
    standalone: false
})
export class FilterFnPipe implements PipeTransform {
  transform(items: any[], filterFn: (item: any, ...args: any[]) => boolean, ...args: any[]): any[] {
    if (!items || !filterFn) return items;
    return items.filter(item => filterFn(item, ...args));
  }
}
